import WidgetGrid from "@components/widgets/Grid";
import { SearchFilterV4 } from "@/types/SearchFilter";
import SentimentDistributionWidget from "@components/widgets/SentimentDistribution";
import ReachOverTimeWidget from "@components/widgets/ReachOverTime";
import { differenceInDays } from "date-fns";
import { withDefaultDates } from "@/utils";
import MentionsOverTimeWidget from "@components/widgets/MentionsOverTime";
import ChannelTypesByMentionCountWidget from "@components/widgets/ChannelTypesByMentionCount";
import { generatePath, useLocation } from "react-router-dom";
import { Widget, WidgetContent } from "@components/ui/widget";
import { omitPageParams } from "@/hooks/usePageParam";
import HighlightsWidget from "@components/widgets/Highlights";
import { useSearchSectionRoutes } from "@/hooks/useSearchSectionRoutes";

export default function TopWidgets({
  filters: _filters,
  searchUuid,
  orgUuid,
}: {
  filters: SearchFilterV4;
  searchUuid: Uuid;
  orgUuid: Uuid;
}) {
  // URL state
  const location = useLocation();
  const section = useSearchSectionRoutes();

  // Helpers
  const filters = withDefaultDates(_filters);
  const diffInDays = differenceInDays(filters.end_date, filters.start_date);
  const search = omitPageParams(location.search);
  const reachDetailsLink = `${generatePath(section.insightsReach, {
    uuid: searchUuid,
    orgUuid,
  })}${search}`;
  const sentimentDetailsLink = `${generatePath(section.insightsSentiment, {
    uuid: searchUuid,
    orgUuid,
  })}${search}`;
  const resultsDetailsLink = `${generatePath(section.insightsResults, {
    uuid: searchUuid,
    orgUuid,
  })}${search}`;

  return (
    <WidgetGrid>
      <HighlightsWidget
        className="col-span-12"
        searchUuid={searchUuid}
        filters={filters}
      />

      <ReachOverTimeWidget
        filters={filters}
        searchUuid={searchUuid}
        diffInDays={diffInDays}
        className="col-span-12 @3xl/grid:col-span-6 @4xl/grid:col-span-8 h-32 overflow-visible"
        detailsLink={reachDetailsLink}
      />

      <SentimentDistributionWidget
        className="col-span-12 @3xl/grid:col-span-6 @4xl/grid:col-span-4 h-32"
        searchUuid={searchUuid}
        filters={filters}
        detailsLink={sentimentDetailsLink}
      />

      <Widget className="col-span-12 py-0">
        <WidgetContent className="@5xl/grid:py-6 @5xl/grid:px-0">
          <WidgetGrid className="gap-px bg-border rounded-xl overflow-hidden px-0">
            <MentionsOverTimeWidget
              className="col-span-12 @5xl/grid:col-span-8 @5xl/grid:pr-1 @5xl/grid:py-0 h-62"
              searchUuid={searchUuid}
              diffInDays={diffInDays}
              filters={filters}
              detailsLink={resultsDetailsLink}
            />

            <ChannelTypesByMentionCountWidget
              className="col-span-12 @5xl/grid:col-span-4 @5xl/grid:pl-1 @5xl/grid:py-0 h-62"
              searchUuid={searchUuid}
              filters={filters}
            />
          </WidgetGrid>
        </WidgetContent>
      </Widget>
    </WidgetGrid>
  );
}
